import axios from 'axios';

// Ouvre le PDF dans un nouvel onglet pour impression.
// Le nouvel onglet est créé immédiatement pour éviter le blocage des pop-ups.
export async function imprimerBonVersement(apiUrl, userId, apitoken, idversement) {
  const onglet = window.open('', '_blank');
  if (!onglet) throw new Error('Autorisez les fenêtres pop-up pour imprimer le bordereau.');
  try {
    onglet.document.title = 'Chargement du bon de versement';
    onglet.document.body.textContent = 'Préparation du bon de versement…';
    const { data } = await axios.get(
      `${apiUrl}generer/bonversement/${userId}/${apitoken}/${idversement}`,
      { responseType: 'blob', timeout: 30000 }
    );
    const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
    onglet.location.replace(url);
    // Le navigateur affiche le PDF. L'utilisateur peut imprimer avec Ctrl+P.
    // Ne pas révoquer l'URL immédiatement : le lecteur PDF en a besoin.
    setTimeout(() => URL.revokeObjectURL(url), 120000);
  } catch (error) {
    onglet.close();
    throw error;
  }
}
